import React, { useEffect, useRef } from "react";
import { Container, Row, Col, Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Recruit.css";

// ─── 職種データ ───────────────────────────────────────────────────
const JOBS = [
  {
    title: "⚡ 電気設計",
    frontText: "最先端の制御設計に挑戦できる環境です。",
    backJob: "制御設計 / 制御システム開発",
    backPerson: "挑戦心と探究心を持つ方",
    className: "left",
  },
  {
    title: "⚙️ 機械設計",
    frontText: "精密機械の設計・開発を担うエンジニア募集。",
    backJob: "CADによる設計 / 試作・検証",
    backPerson: "創造力と技術力を発揮したい方",
    className: "center",
  },
  {
    title: "🏭 製造職",
    frontText: "高品質な製品づくりに携わる仕事です。",
    backJob: "製造ライン作業 / 品質管理",
    backPerson: "チームで協力しながら働ける方",
    className: "right",
  },
  {
    title: "🛠 開発機械設計職",
    frontText: "新しい機械の開発・設計に挑戦できます。",
    backJob: "機械設計 / 試作・評価",
    backPerson: "技術力と創造力を発揮したい方",
    className: "left",
  },
  {
    title: "📊 生産管理職",
    frontText: "効率的な生産体制の構築・管理を担当します。",
    backJob: "生産計画 / 工程管理 / コスト管理",
    backPerson: "分析力とマネジメント力を持つ方",
    className: "center",
  },
];

export default function Recruit() {
  const cardRefs    = useRef([]);
  const RecruitheroTitleRef = useRef(null);
  const RecruitheroSubRef   = useRef(null);
  const RecruitheroBtnRef   = useRef(null);

  // ─── IntersectionObserver（一度表示したら監視停止）──────────────
  // CSS: .anim-fade-up.is-visible（旧 .fade-up.in-view）
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    [RecruitheroTitleRef.current, RecruitheroSubRef.current, RecruitheroBtnRef.current, ...cardRefs.current]
      .filter(Boolean)
      .forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="recruit-page">
      <div id="page-top" />

      {/* ── Hero ──────────────────────────────────────────── */}
      <section className="recruit-hero-section">
        <video
          className="recruit-hero-video"
          autoPlay
          loop
          muted
          playsInline
          disablePictureInPicture
          controlsList="nodownload nofullscreen noremoteplayback"
        >
          <source src="/videos/factory.mp4" type="video/mp4" />
        </video>

        <div className="recruit-hero-overlay">
          {/* CSS: .anim-fade-up（旧 .fade-up） */}
          <h1 ref={RecruitheroTitleRef} className="recruit-hero-title anim-fade-up">
            あなたの挑戦を待っています
          </h1>
          <p ref={RecruitheroSubRef} className="recruit-hero-sub anim-fade-up">
            Join Our Team at <span className="zenkyo-light">ZENKYO</span>
          </p>
          <Button
            ref={RecruitheroBtnRef}
            variant="light"
            size="lg"
            className="mt-4 recruit-hero-btn anim-fade-up"
            as={Link}
            to="/entry#page-top"
          >
            エントリーする
          </Button>
        </div>
      </section>

      {/* ── Company Intro ──────────────────────────────────── */}
      <section className="recruit-intro-section py-5">
        <Container>
          <Row className="text-center">
            <Col>
              <h2>60年の信頼と挑戦</h2>
              <p>
                <span className="zenkyo-light">ZENKYO</span>は常に未来を切り拓く仲間を求めています。
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* ── Jobs ──────────────────────────────────────────── */}
      <section className="recruit-jobs-section">
        <Container>
          <Row>
            {JOBS.map((job, idx) => (
              <Col
                xs={12}
                md={4}
                key={job.title}
                ref={(el) => (cardRefs.current[idx] = el)}
                className="anim-fade-up"
              >
                <Card className={`recruit-flip-card text-center ${job.className}`}>
                  <div className="recruit-flip-card-inner">
                    <div className="recruit-flip-card-front">
                      <Card.Body>
                        <h3>{job.title}</h3>
                        <p>{job.frontText}</p>
                      </Card.Body>
                    </div>
                    <div className="recruit-flip-card-back">
                      <Card.Body>
                        <h4>仕事内容</h4>
                        <p>{job.backJob}</p>
                        <h4>求める人物像</h4>
                        <p>{job.backPerson}</p>
                      </Card.Body>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* ── CTA ───────────────────────────────────────────── */}
      <section className="recruit-cta-section">
        <div>
          <h2>さあ、新しい挑戦を始めよう</h2>
          <Button
            variant="light"
            size="lg"
            className="mt-3 recruit-cta-btn"
            as={Link}
            to="/entry#page-top"
          >
            応募はこちら
          </Button>
        </div>
      </section>
    </div>
  );
}
